<template>
  <canvas :ref="ref"></canvas>
</template>

<script>

import Chart from 'chart.js';


export default {

  props: ['data'],

  name: '',
  data() {
    return {
      ref: `bars-${Math.random().toString(36).substring(7)}`,
      myChart:undefined,
      datasets:[]
    };
  },
  mounted() {
    let total = 0;
    if(typeof this.data.errors == 'undefined' && typeof this.data.states != 'undefined')
    {
      total = this.data.states.analyze + this.data.states.contacted + this.data.states.help + this.data.states.confirmed + this.data.states.checked + this.data.states.solved;
      this.datasets = [{
                data: [this.data.states.analyze + this.data.states.contacted + this.data.states.help],
                backgroundColor: "#d5535f",
                hoverBackgroundColor: "#cd404d",


            },{
                data: [this.data.states.checked + this.data.states.confirmed],
                backgroundColor: "#ff9800",
                hoverBackgroundColor: "#ffa944",

            },{
                data: [this.data.states.solved],
                backgroundColor: "#2e5f40",
                hoverBackgroundColor: "#245837",

            }];
    }
    else if(typeof this.data.errors == 'object')
    {
      this.datasets = [{
                data: [this.data.errors.malfunction + this.data.errors.request + (this.data.end ? this.data.end : 0)],
                backgroundColor: "#d5535f",
                hoverBackgroundColor: "#cd404d",


            },{
                data: [this.data.expected],
                backgroundColor: "#38885f",
                hoverBackgroundColor: "#2d7e55",  

            },{
                data: [this.data.recieved],
                backgroundColor: "#2e5f40",
                hoverBackgroundColor: "#245837",

            }];
      total = this.data.errors.malfunction + this.data.errors.request + this.data.expected + this.data.recieved + (this.data.end ? this.data.end : 0);
      if(this.data.reask != undefined)
      {
        total += this.data.reask;
        this.datasets.push({
                data: [this.data.reask],
                backgroundColor: "#ff9800",
                hoverBackgroundColor: "#ffa944",

            });
      }
      if(this.data.errors.new != undefined)
      {
        total += this.data.errors.new;
        this.datasets.push({
                data: [this.data.errors.new],
                backgroundColor: "#212121",
                hoverBackgroundColor: "#444444",

            });
      }
    }
    else
    {
      this.datasets = [{
                data: [this.data.errors],
                backgroundColor: "#d5535f",
                hoverBackgroundColor: "#cd404d",
            },{
                data: [this.data.expected],
                backgroundColor: "#38885f",
                hoverBackgroundColor: "#2d7e55", 

            },{
                data: [this.data.recieved],
                backgroundColor: "#2e5f40",
                hoverBackgroundColor: "#245837", 

            }];
      total = this.data.errors + this.data.expected + this.data.recieved;
    }
    const chart = this.$refs[this.ref];
    const ctx = chart.getContext('2d');
    this.myChart = new Chart(ctx, {
      type: 'horizontalBar',
      data: {
          
          datasets: this.datasets
        },
        options: {

          tooltips: {
              enabled: false
          },
          layout: {
            padding: {
              left:-10,
              right: 0,
              top: -35,
              bottom: 0,
            },
          },
          legend:{
              display:false
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
              xAxes: [{
                  display: false,
                  padding: 0,
                  stacked: true,
                  ticks:
                  {
                    max:total
                  }
              }],
              yAxes: [{
                padding: 0,
                barPercentage: 1.0,
                categoryPercentage: 1.0,
                ticks: {
                    display: false,
                    padding: 0,
                },
                stacked: true,
              }]
          },
          title: {
            display: true,
          },
        },
    });

  },

};
</script>
